import React from 'react'
import selfie from '../images/pfp.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import {
  faXTwitter,
  faGithub,
  faLinkedin,
  faDocker,
  faTelegram
} from "@fortawesome/free-brands-svg-icons";
import { Helmet } from "react-helmet";


const About = () => {
  return (
    <section id="about">
      <Helmet>
        <html lang="en" />

        <meta
          name="description"
          content="Computer Science, Programming Portfolio"
        />
      </Helmet>
        <div class="container" >
            <div class="columns is-centered">
                <div class="column">
                <img class="avatar" src={selfie}/>
                <div class="about-title has-text-centered">
              <h1 class="title is-2">Sailesh Polavarapu</h1>
              <p class="title is-6" style={{fontWeight: 'normal', marginTop: '-0.5rem'}}>[ ◉¯]<i> Visiting the Mountain View Computer History Museum. 2025</i></p>
              <div class="has-text-centered">
              {/* <span class="about-subtitle" style={{fontSize: "150%"}}>
                ⟨ Software Engineer | Full-Stack Developer ⟩
                </span> */}
                {/* <span class="about-subtitle" style={{fontSize: "150%"}}>
                ⟨ Software Engineer | Full-Stack Developer ⟩
                </span> */}
            </div>
            </div>
                </div>
                <div class="column">
                <p>

                I'm an MTS at<a href="https://www.judgmentlabs.ai/" target="_blank" rel="noopener noreferrer" style={{color: 'rgb(255, 75, 46)', textDecoration: 'none'}}> Judgment Labs</a> and Computer Science alum from the{" "}
                
                <span className="tooltip">
              <abbr title="">University of Waterloo</abbr>.
              <span className="tooltiptext" style={{zIndex: "10000"}}>Honours Bachelor of Computer Science 2026</span>
            </span>{" "} 
            <br/><br/>
            During my undergraduate degree I was fortunate to research the application of matrix multiplication to speed up database query processing under <a href="https://cs.uwaterloo.ca/~xiaohu/" target="_blank">Dr. Xiao Hu</a>, and the applications of ZK Proofs on ML models under <a href="https://sergeyg.tech/" target="_blank">Dr. Sergey Gorbunov</a>.
            <br/><br/>
            I spent the majority of my extracurricular time with the Waterloo Blockchain club, which I went with to win at the world's largest Ethereum <a href="https://uwaterloo.ca/computer-science/news/waterloo-students-win-nearly-100k-usd-ethdenver-2025" target="_blank">hackathon</a> in both 2024 and 2025.
            <br/><br/>
            Feel free to reach out to me about anything. My socials are below.

              </p>
{/*               
              <p>
              I'm a skilled {" "}
              <span style={{ color: "#339fde" }} className="tooltip">
              <abbr title="">Full-Stack developer</abbr>
              <span className="tooltiptext">React.js, Express.js, Node.js</span>
            </span> {" "}
              (my usual role during hackathons + I've made multiple projects),
              a
              {" "}
              <span style={{ color: "#339fde" }} className="tooltip">
              <abbr title="">Software Engineer</abbr>
              <span className="tooltiptext">Java, Kotlin, C++, Python, (Java/Type)Script</span>
            </span>,{" "}
              <span style={{ color: "#339fde" }} className="tooltip">
              <abbr title="">Database Designer</abbr>
              <span className="tooltiptext">Mongoose, MongoDB, SQL, NoSQL</span>
            </span>, 
              
              and an AWS certified cloud practitioner (this just means I'm good at deploying applications to AWS).
              <br/><br/>


            
          </p> */}

          {/* <h3 class="special">What I'm working on 👨‍💻</h3>
          <ul id="interests">
            <li>
              <input type="checkbox" disabled></input>
              &nbsp;&nbsp;&nbsp;&nbsp;Low Level Programming

            </li>
            <li>
              <input type="checkbox" disabled></input>
              &nbsp;&nbsp;&nbsp;&nbsp;Learning about Computer Networking

            </li>
            <li>
            <input type="checkbox" disabled></input>
            &nbsp;&nbsp;&nbsp;&nbsp;Hackathons
            </li>
          </ul>
                <br />
                <h3 class="special">My Blockchain Work 🦄	</h3>
                <ul id="interests">
                <li>
            <input type="checkbox" disabled></input>
            &nbsp;&nbsp;&nbsp;&nbsp;ETHDenver 2025 InfoFi &#8212; First Place Hedera and ZKVerify, EigenLayer House Second Tier Winner
              
            </li>
            <li>
              <input type="checkbox" disabled></input>
              &nbsp;&nbsp;&nbsp;&nbsp;ZKML Undergraduate Research Term under Doctor Sergey Gorbunov
            </li>
            <li>
              <input type="checkbox" disabled></input>
              &nbsp;&nbsp;&nbsp;&nbsp;UWaterloo Blockchain Club Executive

            </li>
            <li>
            <input type="checkbox" disabled></input>
            &nbsp;&nbsp;&nbsp;&nbsp;ETHDenver 2024 ZKSnake &#8212; First Place MetaMask & Risc0
              
            </li>
            <li>
            <input type="checkbox" disabled></input>
            &nbsp;&nbsp;&nbsp;&nbsp;ZK Vector DB &#8212; Bounty at Frontiers by Paradigm x Succint Labs
              
            </li>
            <li>
            <input type="checkbox" disabled></input>
            &nbsp;&nbsp;&nbsp;&nbsp;ChainSafe Web3.js NFT Plugin &#8212; Second Place
            </li>
            <li>
            <input type="checkbox" disabled></input>
            &nbsp;&nbsp;&nbsp;&nbsp;The Graph Foundation USDT Account Relations Subgraph &#8212; First Place
            </li>
          </ul>
          <br /> */}
          <div class="social-links" style={{display: 'flex', flexWrap: 'wrap', gap: '20px', marginTop: '20px'}}>
            <a href="https://linkedin.com/in/saileshpola" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: '#339fde', fontSize: '16px', padding: '6px 8px'}}>
              <FontAwesomeIcon icon={faLinkedin} size="xl" />
              <span style={{color: '#2fb161'}}>LinkedIn</span>
            </a>
            <a href="https://twitter.com/Unhingexd" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: '#339fde', fontSize: '16px', padding: '6px 8px'}}>
              <FontAwesomeIcon icon={faXTwitter} size="xl" />
              <span style={{color: '#2fb161'}}>X/Twitter</span>
            </a>
            <a href="https://github.com/saileshp56" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: '#339fde', fontSize: '16px', padding: '6px 8px'}}>
              <FontAwesomeIcon icon={faGithub} size="xl" />
              <span style={{color: '#2fb161'}}>GitHub</span>
            </a>
            <a href="mailto:saileshp.dev@gmail.com" style={{display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: '#339fde', fontSize: '16px', padding: '6px 8px'}}>
              <FontAwesomeIcon icon={faEnvelope} size="xl" />
              <span style={{color: '#2fb161'}}>Email</span>
            </a>
            <a href="/WebsiteResume2026.pdf" target="_blank" rel="noopener noreferrer" style={{display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', color: '#339fde', fontSize: '16px', padding: '6px 8px'}}>
              <FontAwesomeIcon icon={faFilePdf} size="lg" />
              <span style={{color: '#2fb161'}}>Resume</span>
            </a>
          </div>

                </div>

            </div>

        </div>
        
    </section>
  )
}

export default About